import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productRecsItemName',
  standalone: true,
})
export class ProductRecsItemNamePipe implements PipeTransform {
  /**
   * @description Used to replace some special characters in item names
   **/
  transform(value: string) {
    if (value) {
      return value.replace('&amp;', '&').replace('&#8211;', '-');
    }

    return '';
  }
}
